import { render, staticRenderFns } from "./LankapayIcon.vue?vue&type=template&id=616a8d96&"
import script from "./LankapayIcon.vue?vue&type=script&lang=js&"
export * from "./LankapayIcon.vue?vue&type=script&lang=js&"
import style0 from "./LankapayIcon.vue?vue&type=style&index=0&id=616a8d96&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports